class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.chatButton = null;
    this.isStickyVisible = false;
  }
  connectedCallback() {    
    this.boundSyncFromProductForm = this.syncFromProductForm.bind(this);
    document.addEventListener("change", this.boundSyncFromProductForm);

    this.stickyQuantityInputIncrement = this.querySelector(".new-sticky-atc-bar__quantity-btn--plus");
    this.stickyQuantityDecrement = this.querySelector(".new-sticky-atc-bar__quantity-btn--minus");
    this.stickyQuantityInput = this.querySelector(".new-sticky-atc-bar__quantity-input");
    this.stickyAddToCartButton = this.querySelector(".new-sticky-atc-bar__button");

    this.stickyQuantityInputIncrement.addEventListener("click", this.settingQuantityValue.bind(this));
    this.stickyQuantityDecrement.addEventListener("click", this.settingQuantityValue.bind(this));
    this.stickyAddToCartButton.addEventListener("click", () => {
      document.querySelector("product-form .product-form__submit").click();
    });

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        this.querySelector(".new-sticky-atc-bar").setAttribute("aria-hidden", entry.isIntersecting);   
        this.isStickyVisible = !entry.isIntersecting;
        this.adjustChatButton();
      });
    });

    const productForm = document.querySelector('product-form');
    if (productForm) this.observer.observe(productForm);

    // Watch for the chat button being added to the DOM
    this.watchForChatButton();

  }
  syncFromProductForm(e) {
    if (!e.target.matches('quantity-input input[form^="product-form"]')) return;
    this.stickyQuantityInput.value = e.target.value;
    // this.calculatePrice(this.stickyQuantityInput.value);
  }

  settingQuantityValue(e) {
    let currentValue = parseInt(this.stickyQuantityInput.value, 10) || 1;
    const pdpQuantityInput = document.querySelector(".quantity-selector-custom quantity-input .quantity__input");
    if(e.currentTarget.hasAttribute("data-sticky-atc-qty-increase")) {
      currentValue++;
      pdpQuantityInput.stepUp();
    }
    else if (e.currentTarget.hasAttribute("data-sticky-atc-qty-decrease") && currentValue > 1) {
      currentValue--;
      pdpQuantityInput.stepDown();
    }

    this.stickyQuantityInput.value = currentValue;
    // this.calculatePrice(this.stickyQuantityInput.value);
  }
  // calculatePrice(quantity) {
  //   const totalCents = parseInt(this.querySelector(".button__price").dataset.price, 10) * quantity;
  //   this.querySelector(".button__price").textContent = this.formatMoney(totalCents);    
  // }
  // formatMoney(cents) {
  //   return `$${(cents / 100).toFixed(2)}`;
  // }
  watchForChatButton() {
    const CHAT_SELECTORS = ['#chat-button', 'iframe#chat-button'].join(', ');

    // Check if already present
    const existing = document.querySelector(CHAT_SELECTORS);
    if (existing) {
      this.chatButton = existing;
      this.adjustChatButton();
      return;
    }

    // Otherwise watch for it
    this.chatObserver = new MutationObserver(() => {
      console.log("Mutation detected, looking for chat button...");
      const chatButton = document.querySelector(CHAT_SELECTORS);
      if (chatButton && chatButton !== this.chatButton) {
        this.chatButton = chatButton;
        this.adjustChatButton();
      }
    });

    this.chatObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  adjustChatButton() {
    if (!this.chatButton) return;
    this.chatButton.style.transition = 'bottom 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
    this.chatButton.style.bottom = this.isStickyVisible ? '90px' : '20px';
    const backtoTop = document.querySelector("#back-to-top-container");
    backtoTop.style.transition = 'bottom 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
    backtoTop.style.bottom = this.isStickyVisible ? '170px' : '90px';
  } 
  disconnectedCallback() {
    this.observer?.disconnect();
    this.chatObserver?.disconnect();
    document.removeEventListener("change", this.boundSyncFromProductForm);
  }

}
customElements.define("sticky-add-to-cart", StickyAddToCart);